import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { WorkflowStepPropertyCodes } from '@hub4b/constantes/workflow-step-property-codes';
import { TableWorkflowCellTooltipComponent } from '@hub4b/controls/datas-list/table-workflow-cell/table-workflow-cell-tooltip.component/table-workflow-cell-tooltip.component';
import { ComponentToolTipDirective } from '@hub4b/directives/component-tool-tip.directive';
import { Folder } from '@hub4b/models/server/folder';
import { FolderWorkflowStepsSnapshot } from '@hub4b/models/server/folder-workflow-steps-snapshot';
import { WorkflowStepColumnDefinition } from '@hub4b/models/server/workflow-step-column-definition';
import { AvmFolderWorkflowCellPipe } from '@hub4b/pipes/avm-folder-workflow-cell.pipe';

@Component({
    selector: 'app-table-workflow-cell',
    templateUrl: './table-workflow-cell.component.html',
    styleUrls: ['./table-workflow-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, AvmFolderWorkflowCellPipe, ComponentToolTipDirective]
})
export class TableWorkflowCellComponent implements OnInit {
    WorkflowStepPropertyCodes = WorkflowStepPropertyCodes;

    @Input()
    public column: WorkflowStepColumnDefinition;

    /** Instance du dossier affiché sur cette ligne. */
    @Input()
    row: Folder;

    /**
     * Valeur indiquant si les dates de changement d'état des étapes de workflow sont visibles.
     */
    @Input()
    public isWorkflowStepDateVisible: boolean;

    @Output()
    expandOrCollapseRow: EventEmitter<Folder> = new EventEmitter<Folder>();

    public TooltipWorkflowStepComponent = TableWorkflowCellTooltipComponent;

    public workflowStepsSnapshot: FolderWorkflowStepsSnapshot = null;

    ngOnInit(): void {
        this.workflowStepsSnapshot = this.row.workflowStepsSnapshot?.find((x) => x.workflowStepId.toString() == this.column.propertyCode);
    }
}
